const config = {
  default: {
    name: "Trackmydoc",
    domainName: "trackmydoc.com",
    clientUrl: "https://client.trackmydoc.com",
  },
  "rv-backoffice.9dottechno.com": {
    name: "RV Accounting",
    domainName: "9dottechno.com",
    logo: "/assets/logo/logo.png",
    favicon: "/assets/logo/favicon.png",
    clientUrl: "https://rv-client.9dottechno.com",
  }
};

const getSiteConfig = () => {
  const hostname = window.location.hostname;
  const matchedKey = Object.keys(config).find((key) => hostname.includes(key));
  return config[matchedKey] || config["default"];
};

const siteConfig = getSiteConfig();

export default siteConfig;
